import { render, staticRenderFns } from "./SupplierBankAccountNotif.vue?vue&type=template&id=43ca8188&"
import script from "./SupplierBankAccountNotif.vue?vue&type=script&lang=js&"
export * from "./SupplierBankAccountNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports